import restfulFetch from '@/utils/request'

// 获取说明
export async function fetchVersion(): Promise<string> {
  const url = `/version.json?t=${new Date().getTime()}`
  const res = await restfulFetch({
    url,
    data: {},
    method: 'get',
  })
  return res.data || ''
}
